'use strict';

var $ = require('jquery');
var keyCodes = require('../constants/key-codes');
var toggle = require('../components/toggle');
var offcanvasdialog = require('../components/offcanvasdialog');
var lodash = require('../components/custom-lodash');
var optiExperiment = require('../components/optimizelyExperimentation');

var activeClass = 'active';
var addGapClass = 'm-add_gap';
var $linkToReactivate = null;
var lastScrollHeight = 0;

var $window = $(window);
var $body = $('body');
var $searchTrigger = $('.header-mobile-search-trigger');
var searchTriggerOpenLabel = $searchTrigger.data('open-label') || $searchTrigger.attr('aria-label');
var searchTriggerCloseLabel = $searchTrigger.data('close-label') || $searchTrigger.attr('aria-label');

var $menuTrigger = $('.header-mobile-menu-trigger');
var menuTriggerOpenLabel = $menuTrigger.data('open-label') || $menuTrigger.attr('aria-label');
var menuTriggerCloseLabel = $menuTrigger.data('close-label') || $menuTrigger.attr('aria-label');

var disableLink = function () {
    if ($linkToReactivate === null) {
        $linkToReactivate = $('.static-link.active');
        $linkToReactivate.removeClass(activeClass);
    }
};

var reActivateLink = function () {
    if ($linkToReactivate && $linkToReactivate.length) {
        $linkToReactivate.addClass(activeClass);
        $linkToReactivate = null;
    }
};

var closeMenu = function ($triggerButton, dialog) {
    $triggerButton.off('click');
    $triggerButton.removeClass(activeClass);
    $triggerButton.attr('aria-label', menuTriggerOpenLabel);
    if (dialog) {
        dialog.hide();
    }
    reActivateLink();
};

var closeSlideDownMenu = function ($triggerButton, $content) {
    $triggerButton.removeClass(activeClass);
    $triggerButton.attr('aria-label', searchTriggerOpenLabel);
    $content.slideUp(400);
    $content.find('input[type="text"]').val('');
    reActivateLink();
};

var navigateForward = function (e, $container, $closeButton) {
    e.preventDefault();
    var $tabbable = $container.findTabbable();
    var $firstTabbable = $tabbable.first();
    var $lastTabbable = $tabbable.last();
    var $element = $(e.target);
    var currentPosition = $tabbable.index($element);
    var $nextElement = $tabbable[++currentPosition];

    if ($element.is($closeButton)) {
        $firstTabbable.focus();
    } else if ($element.is($lastTabbable)) {
        $closeButton.focus();
    } else {
        $nextElement.focus();
    }
};

var navigateBackward = function (e, $container, $closeButton) {
    e.preventDefault();
    var $tabbable = $container.findTabbable();
    var $firstTabbable = $tabbable.first();
    var $lastTabbable = $tabbable.last();
    var $element = $(e.target);
    var currentPosition = $tabbable.index($element);
    var $previousElement = $tabbable[--currentPosition];

    if ($element.is($closeButton)) {
        $lastTabbable.focus();
    } else if ($element.is($firstTabbable)) {
        $closeButton.focus();
    } else {
        $previousElement.focus();
    }
};

exports.init = async function () {
    const $mobileHeader = $('.header-wrapper.hide-on-desktop').not('.loaded');
    const $searchForm = $('.header-mobile-search-form');
    const $searchInput = $('.header-mobile-search-input');
    const $searchInputTablet = $('.header-tablet-search-input');
    const $searchButton = $('.search-icon-button');
    const $mobileHeaderMain = $('.header-wrapper.hide-on-desktop .header-mobile-main');
    const $headerMobileSearch = $('.header-mobile-search.hide-on-tablet.header-search');
    let menuClosed = null;

    if ($mobileHeader.length) {
        var beforeHideSearch = null;
        var afterHideSearch = null;
        var beforeShowSearch = null;
        var afterShowSearch = null;

        var toggleSearchForm = function (toggle, onTransitionStart, onTransitionEnd) {
            if (onTransitionStart) onTransitionStart();
            if (toggle) {
                $searchForm.slideDown(400, onTransitionEnd);
            } else {
                $searchForm.slideUp(400, onTransitionEnd);
            }
        };

        let moveStickyOptions = function (isSearchFormInView) {
            const stickyOptions = $('.listing-options.is-sticky');
            let isPlpContext = stickyOptions && !!stickyOptions.length;
            if (isPlpContext) {
                //@header-mobile-height = 48px
                const headerMobileHeight = 48;
                let total = headerMobileHeight;
                if (isSearchFormInView) {
                    let searchFormHeight = $searchForm.outerHeight();
                    let searchFormTopPosition = $searchForm.position().top;
                    let searchFormBottomEdge = searchFormHeight + searchFormTopPosition;
                    total = searchFormBottomEdge + headerMobileHeight;
                }
                stickyOptions.css('top', total + 'px');
            }
        };

        var showSearchForm = function (onTransitionStart, onTransitionEnd) {
            toggleSearchForm(true, onTransitionStart, onTransitionEnd);
        };

        var hideSearchForm = function (onTransitionStart, onTransitionEnd) {
            toggleSearchForm(false, onTransitionStart, onTransitionEnd);
        };

        beforeHideSearch = function () {
            moveStickyOptions(false);
            $window.off('scroll.mobilesearch');
            $mobileHeader.removeClass('m-search-form-shown');
        };

        beforeShowSearch = function () {
            $window.off('scroll.mobilesearch');
            $mobileHeader.addClass('m-search-form-shown');
        };

        if ($headerMobileSearch.length && $headerMobileSearch[0].dataset.isStickyBarEnable === 'true') {
            $mobileHeader.addClass('m-feature-testing m-search-form-shown');

            var attachScrollEvent = function () {
                $window.on(
                    'scroll.mobilesearch',
                    lodash.throttle(function () {
                        const currentHeight = $window.scrollTop();

                        if (lastScrollHeight !== 0 && currentHeight > 0) {
                            if (currentHeight > lastScrollHeight && !$mobileHeaderMain.hasClass('search-active')) {
                                hideSearchForm(beforeHideSearch, () => {
                                    lastScrollHeight = 0;
                                    attachScrollEvent();
                                });
                            } else if (currentHeight < lastScrollHeight) {
                                showSearchForm(beforeShowSearch, () => {
                                    lastScrollHeight = 0;
                                    moveStickyOptions(true);
                                    attachScrollEvent();
                                });
                            }
                        }

                        lastScrollHeight = currentHeight;
                    }, 100)
                );
            };

            afterShowSearch = afterHideSearch = attachScrollEvent;
            attachScrollEvent();
        }

        $searchInput.on('click', function () {
            if (!$mobileHeaderMain.hasClass('search-active')) {
                $searchTrigger.trigger('click');
            }
        });

        $body.on('suggestions:show', function () {
            $mobileHeader.addClass('m-suggestions-shown');
        });

        $body.on('suggestions:hide', function () {
            $mobileHeader.removeClass('m-suggestions-shown');
        });

        const menu = offcanvasdialog.init(
            'header-mobile-menu-trigger',
            {
                position: document.documentElement.lang === 'ar' ? 'right' : 'left',
                overlay: true,
                closeOnClick: true,
                closeOnX: false,
                additionalClass: 'header-mobile-menu-fly-in'
            },
            function ($triggerButton, $flyinContainer) {
                closeSlideDownMenu($searchTrigger, $searchForm);
                disableLink();
                $('.mobile-menu-section .content-asset .toggle').attr('tabindex', 0);
                $menuTrigger.addClass(activeClass);
                $flyinContainer.addClass(addGapClass);
                $menuTrigger.attr('aria-expanded', 'true');
                $menuTrigger.attr('aria-label', menuTriggerCloseLabel);
                $menuTrigger.on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                });

                $flyinContainer
                    .find('p.first-level[data-nav-category-id], p.second-level[data-nav-category-id], p.link')
                    .on('keydown touchend', function (event) {
                        const $this = $(this);
                        const dataCategoriesNavLvl = $this[0].dataset.navCategoryId;
                        let dataCategoriesNavParent = '-';
                        let dataCategoriesNavParentLvlTwo = '-';
                        let dataCategoriesNavParentLvlThree = '-';

                        if ($this.hasClass('first-level')) {
                            dataCategoriesNavParent = dataCategoriesNavLvl.toLowerCase();
                        } else if ($this.hasClass('second-level')) {
                            dataCategoriesNavParent = $this.parent()[0].dataset.parentNavCategoryId.toLowerCase();
                            dataCategoriesNavParentLvlTwo = dataCategoriesNavLvl.toLowerCase();
                        } else if ($this.hasClass('link')) {
                            dataCategoriesNavParent = $this.closest('div')[0].dataset.navMainCat.toLowerCase();
                            dataCategoriesNavParentLvlTwo = $this
                                .closest('div')[0]
                                .dataset.parentNavCategoryId.toLowerCase();
                            let categories = JSON.parse($this.closest('a')[0].dataset.categories);
                            dataCategoriesNavParentLvlThree = categories.sub.toLowerCase();
                        }

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'navClicked',
                                clickedNavLevel1: dataCategoriesNavParent,
                                clickedNavLevel2: dataCategoriesNavParentLvlTwo,
                                clickedNavLevel3: dataCategoriesNavParentLvlThree
                            });
                        }
                    });

                toggle.init($flyinContainer, true);
            }
        );

        var $flyin = $('.ocd-flyin');
        $flyin.attr('id', 'mobile-menu-flyin');

        $flyin.on('keydown', function (e) {
            switch (e.which) {
                case keyCodes.TAB:
                    e.shiftKey ? navigateBackward(e, $flyin, $menuTrigger) : navigateForward(e, $flyin, $menuTrigger);
                    break;
                case keyCodes.DOWN:
                    navigateForward(e, $flyin, $menuTrigger);
                    break;
                case keyCodes.UP:
                    navigateBackward(e, $flyin, $menuTrigger);
                    break;
            }
        });

        $menuTrigger.on('keydown', function (e) {
            e.stopPropagation();

            if ($(this).hasClass('active')) {
                // Menu Is Open
                switch (e.which) {
                    case keyCodes.ENTER:
                    case keyCodes.SPACE:
                        e.preventDefault();
                        menu.hide();
                        break;
                    case keyCodes.TAB:
                        e.shiftKey
                            ? navigateBackward(e, $flyin, $menuTrigger)
                            : navigateForward(e, $flyin, $menuTrigger);
                        break;
                    case keyCodes.DOWN:
                        navigateForward(e, $flyin, $menuTrigger);
                        break;
                    case keyCodes.UP:
                        navigateBackward(e, $flyin, $menuTrigger);
                        break;
                }
            } else {
                // Menu Is Closed
                switch (e.which) {
                    case keyCodes.ENTER:
                    case keyCodes.SPACE:
                    case keyCodes.DOWN:
                    case keyCodes.UP:
                        e.preventDefault();
                        $menuTrigger.click();
                        break;
                }

                // If the up arrow key was pressed, wait for the menu to be fully loaded and visible
                // before moving the focus to the last element in it.
                if (e.which === keyCodes.UP) {
                    var checkMenuOpen = setInterval(function () {
                        var $tabbable = $('.ocd-flyin').findTabbable();

                        if ($tabbable.length) {
                            $tabbable.last().focus();
                            clearInterval(checkMenuOpen);
                        }
                    }, 200);
                }
            }
        });

        $('.ocd-flyin')
            .on('hide', function (event, currentMenu) {
                if (currentMenu.triggerClass === 'header-mobile-menu-trigger') {
                    $menuTrigger.removeClass(activeClass);
                    $menuTrigger.attr('aria-expanded', 'false');
                    $menuTrigger.attr('aria-label', menuTriggerOpenLabel);
                    $menuTrigger.css('z-index', '');
                    menuClosed = $.Deferred();
                }
            })
            .on('opening', function () {
                $('.ocd-overlay').off('touchend');
                $menuTrigger.attr('aria-expanded', 'true');
                $menuTrigger.attr('aria-label', menuTriggerCloseLabel);
                $menuTrigger.css('z-index', '402');

                // Collapse All Categories
                $('.ocd-flyin').find('.toggle').removeClass('expanded');
                $('.ocd-flyin').find('.toggle-content').hide().removeClass('content-expanded');

                // Wait for the DOM to be rendered before focusing on the first menu item.
                setTimeout(function () {
                    $('.ocd-flyin').findTabbable().first().focus();
                }, 0);
            });

        $('.ocd-flyin').on('hidden', function (event, currentMenu) {
            if (currentMenu.triggerClass === 'header-mobile-menu-trigger') {
                $menuTrigger.off('click');
                if (menuClosed) {
                    menuClosed.resolve();
                }
            }
        });

        $searchTrigger.on('click', function () {
            $.when(menuClosed).done(function () {
                var $overlay = $('.ocd-overlay');

                closeMenu($menuTrigger, menu);
                disableLink();

                if ($searchTrigger.hasClass(activeClass)) {
                    $searchForm.find('input[type="text"]').val('');
                    reActivateLink();
                    $overlay.addClass('fade-out');
                    $overlay.off('touchend');

                    setTimeout(function () {
                        $overlay.removeClass(activeClass);
                        $overlay.removeClass('fade-out');
                    }, 250);
                    $searchTrigger.attr('aria-label', searchTriggerOpenLabel);
                    hideSearchForm(beforeHideSearch, afterHideSearch);
                } else {
                    $overlay.addClass(activeClass);
                    $overlay.on('touchend', function () {
                        $overlay.off('touchend');
                        $searchButton.trigger('click');
                        $searchTrigger.trigger('click');
                    });
                    $searchTrigger.attr('aria-label', searchTriggerCloseLabel);
                    showSearchForm(beforeShowSearch, afterShowSearch);
                }

                $searchTrigger.toggleClass(activeClass);
                $searchButton.trigger('click');
                $mobileHeaderMain.toggleClass('search-active');
                $searchInput.focus();
            });
        });

        $searchInput.add($searchInputTablet).on('change paste keyup', function () {
            var $this = $(this);
            var value = $this.val();

            if (value.length) {
                $this.addClass('has-value');
            } else {
                $this.removeClass('has-value');
            }
        });

        $mobileHeader.addClass('loaded');
    }
};
